import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { TSIconModule, TsButtonModule } from 'tsui';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { TsDialogComponent } from 'tsui/lib/ts-dialog/ts-dialog.component';
import { TaskDetailsKeyDateLinkingComponent } from '@tasks/task-details/task-details-key-date-linking/task-details-key-date-linking.component';
import { Task } from '@tasks/tasks.types';

export interface LinkKeyDateModalData {
  taskListId: number;
}

export interface LinkKeyDateResult {
  title: string;
  fieldName: string;
  linkType: 'linked_key_date_field_as_source' | 'linked_key_date_field_as_target';
}

@Component({
  selector: 'app-link-key-date-modal',
  standalone: true,
  imports: [CommonModule, TsButtonModule, TSIconModule, TsDialogComponent, TaskDetailsKeyDateLinkingComponent],
  template: `
    <ts-dialog title="Link Key Date" (closeDialog)="cancel()">
      <div ts-dialog-body class="pb-5">
        <app-task-details-key-date-linking [task]="task" (updateTask)="onTaskUpdate($event)" [isModal]="true" />
      </div>
      <div ts-dialog-actions class="ts-dialog-actions-container justify-between">
        <div class="flex gap-2">
          <ts-button (click)="cancel()" variant="secondary">Cancel</ts-button>
          <ts-button (click)="link()" variant="primary" [disabled]="!isValid">Add</ts-button>
        </div>
      </div>
    </ts-dialog>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkKeyDateModalComponent {
  task: Task = {} as Task;
  isValid = false;

  constructor(
    private readonly dialogRef: DialogRef<LinkKeyDateResult>,
    @Inject(DIALOG_DATA) private readonly data: LinkKeyDateModalData,
  ) {}

  onTaskUpdate(task: Task): void {
    this.task = task;
    this.isValid = !!(task.linked_key_date_field_as_source || task.linked_key_date_field_as_target);
  }

  cancel(): void {
    this.dialogRef.close();
  }

  link(): void {
    if (this.isValid) {
      this.dialogRef.close({
        title: this.task.title,
        fieldName: this.task.linked_key_date_field_as_source || this.task.linked_key_date_field_as_target,
        linkType: this.task.linked_key_date_field_as_source
          ? 'linked_key_date_field_as_source'
          : 'linked_key_date_field_as_target',
      });
    }
  }
}
